import IMask from 'imask';
class CustomRangeMask extends IMask.MaskedRange {
  // Custom logic derived from doPrepare method of MaskedRange class:
  // https://github.com/uNmAnNeR/imaskjs/blob/master/packages/imask/src/masked/range.js
  doPrepare(char, flags) {
    const str = (this.prepare ? this.prepare(char, this, flags) : char).replace(/\D/g, '');
    const fromStr = String(this.from).padStart(this.maxLength, '0');
    const val = this.value;
    let prepStr = '';
    for (let ci = 0; ci < str.length; ci += 1) {
      const nextVal = val + prepStr + str[ci];
      const [minstr, maxstr] = this.boundaries(nextVal);

      // Special case for February
      if (/^02\//.test(this.parent.value) && nextVal === '3') {
        this.parent.queue += '3';
        prepStr += '0';
      } else if (Number(maxstr) < this.from) {
        prepStr += fromStr[nextVal.length - 1];
      } else if (Number(minstr) > this.to) {
        if (fromStr.length === 2) {
          // Month or day
          if (!this.isComplete) {
            this.parent.queue += str;
          }
          prepStr += '0';
        } else if (nextVal.length === 1) {
          // Year
          this.parent.queue += `9${str}`;
          prepStr += '1';
        }
      } else {
        prepStr += str[ci];
      }
    }
    return prepStr;
  }
}
export default CustomRangeMask;